export const FILE_SIZE_LIMIT_MB = 100;
export const BYTES_PER_MEGABYTE = 1024 * 1024;

export const isFileSizeAboveThreshold = (fileSize) => {
  const totalSizeMB = fileSize / BYTES_PER_MEGABYTE;
  return totalSizeMB > FILE_SIZE_LIMIT_MB;
};
